import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from './contexts/AuthContext';
import { LayoutProvider } from './contexts/LayoutContext';
import { RouteProvider } from './contexts/RouteContext';
import AppRoutes from './AppRoutes';
import { routesConfig } from './routesConfig';
import { AppProviders } from './contexts';
import RouteLoadingSpinner from './components/Common/RouteLoadingSpinner';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { getReactPlugin } from './services/applicationInsights.service';

const App = () => {
  const reactPlugin = getReactPlugin();

  const appContent = (
    <Suspense fallback={<RouteLoadingSpinner />}>
      <AppRoutes />
    </Suspense>
  );

  // Only wrap with AppInsightsContext if the plugin is initialized
  if (reactPlugin) {
    return (
      <AppInsightsContext.Provider value={reactPlugin}>{appContent}</AppInsightsContext.Provider>
    );
  }

  return appContent;
};

export default App;
